// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  margin-bottom: 0 !important;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-20 {
  margin-top: 20px;
}

.text-12 {
  font-size: 12px;
}

.text-14 {
  font-size: 14px;
}

.text-black {
  color: black;
}

.text-black {
  color: black;
}

.rounded-md {
  border-radius: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.p-4 {
  padding: 4px;
}

.cbg-white {
  background-color: white;
}

.container-tips {
  background-color: white;
}

.tips {
  color: black;
}

.m-0 {
  margin: 0;
}

.mt-4 {
  margin-top: 4px !important;
}

.bbg-white {
  background-color: white;
  border-radius: 10px;
  width: 500px;
  padding: 10px;
}

.bbg-white-400 {
  background-color: white;
  border-radius: 10px;
  width: 400px;
  padding: 10px;
}

.text-center {
  text-align: center;
}

.ml-20 {
  margin-left: 20px;
}

.text-left {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/views/base.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ;;AACA;EACI,eAAA;AAEJ;;AACA;EACI,eAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,uBAAA;AAEJ;;AAEA;EAEI,YAAA;AAAJ;;AAGA;EACI,SAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ","sourcesContent":[".card {\n    margin-bottom: 0 !important;\n}\n\n.mt-2 {\n    margin-top: 0.5rem;\n}\n.mt-20 {\n    margin-top: 20px;\n}\n\n.text-12 {\n    font-size: 12px;\n}\n\n.text-14 {\n    font-size: 14px;\n}\n\n.text-black {\n    color: black;\n}\n\n.text-black {\n    color: black;\n}\n\n.rounded-md {\n    border-radius: 10px;\n}\n\n.mb-10 {\n    margin-bottom: 10px;\n}\n\n.mb-20 {\n    margin-bottom: 20px;\n}\n\n.p-4 {\n    padding: 4px;\n}\n\n.cbg-white {\n    background-color: white;\n}\n\n.container-tips {\n    background-color: white;\n}\n\n\n.tips {\n\n    color: black;\n}\n\n.m-0 {\n    margin: 0;\n}\n\n.mt-4 {\n    margin-top: 4px !important;\n}\n\n.bbg-white {\n    background-color: white;\n    border-radius: 10px;\n    width: 500px;\n    padding: 10px;\n}\n\n.bbg-white-400 {\n    background-color: white;\n    border-radius: 10px;\n    width: 400px;\n    padding: 10px;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.ml-20 {\n    margin-left: 20px;\n}\n\n.text-left {\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
